module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "info-event-form form grid",
    attrs: {
      "action": _vm.content.url,
      "method": "post"
    }
  }, [(!_vm.isCsrfCookieSet) ? _c('div', {
    staticClass: "form--fieldset-row"
  }, [_c('div', {
    staticClass: "form--fieldset"
  }, [_c('div', {
    staticClass: "general-error",
    domProps: {
      "textContent": _vm._s(_vm.content.no_cookie_message)
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form--fieldset-row"
  }, _vm._l((_vm.protectedFieldsets), function(fieldset, fieldsetIdx) {
    return _c('fieldset', {
      key: fieldsetIdx,
      staticClass: "form--fieldset"
    }, [_c('div', {
      staticClass: "grid--row form--legend-row"
    }, [_c('div', {
      staticClass: "grid--col form--legend"
    }, [_c('div', {
      staticClass: "form--fieldset-title"
    }, [_c('legend', {
      domProps: {
        "textContent": _vm._s(fieldset.name)
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "grid--col form--fields"
    }, [_c('div', {
      staticClass: "form--field-row"
    }, _vm._l((fieldset.fields), function(field, fieldIdx) {
      return _c(field.component, _vm._b({
        key: field.id,
        tag: "component",
        staticClass: "form--field",
        class: _vm.bemAdd(field.field_facet, 'field'),
        attrs: {
          "disclaimer": _vm.content.disclaimer
        },
        on: {
          "recaptcha-submit": _vm.handleFormSubmit
        },
        model: {
          value: (field.val),
          callback: function($$v) {
            _vm.$set(field, "val", $$v)
          },
          expression: "field.val"
        }
      }, 'component', _vm.bindFieldData(field), false))
    }))])])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36c509a6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36c509a6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/sib-form/index.vue
// module id = 529
// module chunks = 7